<template>
  <div>
    <div class="pageHome flex-col">
      <div class="group_3 flex-row justify-between">
        <img class="label_4" referrerpolicy="no-referrer"
          src="@/assets/SketchPng2e83dc6485d60a9d37bf56f101f7a1aba7a485214a6c3e4e09417085d46ac545.png" />
        <span
          class="text_3">{{$t('views_home_index_51')}} <br v-if="$i18n.locale=='tw'"><br>{{$t('views_home_index_52')}}<br v-if="$i18n.locale=='tw'"><br>{{$t('views_home_index_53')}}</span>
        <div class="group_4 flex-col">
          <div class="text-group_1 flex-col">
            <span class="text_4">PHONE MALL</span>
            <span class="paragraph_1" v-html='$t("desc1")'></span>
          </div>
          <button class="button_1 flex-col">
            <span class="text_5">{{$t("join")}}</span>
          </button>
        </div>
      </div>
      <div class="group_5 flex-col">
        <div class="block_1 flex-row justify-between">
          <button class="button_2 flex-col" @click="$refs.pledge.visible = true">
            <span class="text_9">{{$t('views_home_components_pledge_43')}}</span>
          </button>
        </div>
      </div>
      <div class="group_7 flex-col">
        <div class="image-text_4 flex-row justify-between">
          <img class="image_8" referrerpolicy="no-referrer"
            src="@/assets/SketchPng978d3889c18f054a63e09bfd1e144aff63a3bfbaaf2abb2ab049da9748eed2a9.png" />
          <span class="text-group_5">{{ $t("cooperative") }}</span>
        </div>
        <div class="box_2 flex-row justify-between">
          <div class="tag">
            <img class="image_9" referrerpolicy="no-referrer"
              src="@/assets/SketchPngfd2fb6150cefcec33e3ecb62474397bb1e95870294a6c38196c3ebb42a2caf99.png" />
              ClockWise
          </div>
          <div class="tag" style='font-size: .8rem;'>
            <img class="image_9" referrerpolicy="no-referrer"
              src="@/assets/original_1724484170333_31799b1ccab399884eaf5d4b1754b192.jpg" />
            CoinMarket
          </div>
          <div class="tag">
            <img class="image_9" referrerpolicy="no-referrer"
              src="@/assets/original_1724484278526_f202c3115a29ea4426e4611e4a9e4ef1.jpg" />
              GitHub
          </div>
          <div class="tag">
            <img class="image_9" referrerpolicy="no-referrer"
              src="@/assets/original_1724484074531_b7c868a002bdc48a9253958a9b1a1c26.jpg" />
              BINANCE
          </div>
          <div class="tag">
            <img class="image_9" referrerpolicy="no-referrer"
              src="@/assets/usdt.png" />
            Thther
          </div>
          <div class="tag">
            <img class="image_9" referrerpolicy="no-referrer"
              src="@/assets/aaa.png" />
            Pancakes
          </div>
          <!-- <div class="tag_3 flex-col">
            <img class="image_10" referrerpolicy="no-referrer"
              src="@/assets/original_1724484170333_31799b1ccab399884eaf5d4b1754b192.jpg" />
          </div>
          <div class="tag_3 flex-col">
            <img class="image_10" referrerpolicy="no-referrer"
              src="@/assets/original_1724484278526_f202c3115a29ea4426e4611e4a9e4ef1.jpg" />
          </div> -->
        </div>
        <div class="image-wrapper_4 flex-row">
          <img class="icon_5" referrerpolicy="no-referrer"
            v-if="false"
            src="@/assets/SketchPnga321e1ccd497d29e780454dccfe4ccdd2d73edd992042aaba7e84a3042ddc6c6.png" />
          <img class="label_6" referrerpolicy="no-referrer"
            onclick="window.open('https://twitter.com/clockwisechain','_')"
            src="@/assets/SketchPng084618db57cacc132af140714d4b0c3b369b83d8a211b98ddb9ca73715a5e784.png" />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <img class="image_11" referrerpolicy="no-referrer"
            v-if="false"
            src="@/assets/SketchPnge9016f76aba8209b9922210c1e15392fcdf42c37cfa2eaa7695ba269b91d7cdf.png" />
          <img class="image_11" referrerpolicy="no-referrer" @click="sendEmail" src="@/assets/email.png" />
        </div>
        <appFooter></appFooter>
      </div>
    </div>
    <Bind_dialog v-if="showBindDialog" @success="onRegSuccess"></Bind_dialog>
    <pledge ref="pledge" :userInfo="userInfo" v-if="userInfo"></pledge>
  </div>
</template>
<script>
import i18n from '../../locales/index'

import clock_wise from "@/config/mobile_sale_abi";
import test_coin from "@/config/usdt";
import { mapState } from "vuex";
import Web3, { FMT_BYTES, FMT_NUMBER } from "web3";
import Bind_dialog from "./components/bind_dialog.vue";
import pledge from "./components/pledge.vue";
import { getMobileSaleContract, getSaleStorageContract } from "@/utils/contract";
import web3 from "@/utils/myweb3";
import infuraWeb3 from "@/utils/infura";
import { abiOutputlistToObject } from "@/utils";
export default {
  computed: {
    ...mapState(['userAdd']),
  },
  components: {
    Bind_dialog,
    pledge
  },
  watch: {
    userAdd() {
      if(this.$refs.pledge){
        this.$refs.pledge.visible = false;
      }
      this.showBindDialog = false;
      // this.checkUser();
      this.initData();
    }
  },
  data() {
    return {
      constants: {},
      userInfo:{},
      allowanceMin: Web3.utils.toWei(1000, 'ether'),
      showBindDialog: false,//是否显示绑定弹窗
      showPledge: false,//贡献弹窗
      accelerate: '',//最高赚钱百分比
      rankings: [],
    };
  },
  mounted() {
    // try {
    //   fetch("http://103.255.47.131:8088/").then(console.log).catch(console.log)
    // } catch (error) {
    //   console.error(error)
    // }
    this.initData();
  },
  async created() {

  },
  methods: {
    async initData() {
      if (!this.userAdd) return;
      // 不采用批处理
      this.checkUser();
      // 采用批处理 速度快3倍
      //this.initDataWithBatchRequest();
    },
    onRegSuccess() {
      this.checkUser()
    },
    initDataWithBatchRequest(){
      
      let batchRequest = new infuraWeb3.eth.BatchRequest();
      let contract = getMobileSaleContract()


      let checkUserReq = {
        id: "checkUserReq", method: "eth_call", jsonrpc: '2.0', params: [
          { to: clock_wise.address, data: contract.methods.checkUserInfo(this.userAdd).encodeABI(), from: this.userAdd },
          'latest'
        ]
      };

      batchRequest.add(checkUserReq);
      batchRequest.execute({timeout:1000*3}).then(res => {
        console.log("res", res);
        res.forEach((r, i) => {
          if (i == 0) {
            let user = infuraWeb3.eth.abi.decodeParameter(
              { UserInfo: abiOutputlistToObject(clock_wise.abi.find(e => e.name == 'checkUserInfo').outputs) },
              r.result
            )
            let { level, buyer, refer,quantity, income, unclaimed, peerformance } = user;
            if (buyer != "0x0000000000000000000000000000000000000000" && buyer.toLowerCase() != this.userAdd.toLowerCase()) {
              this.showBindDialog = true;
            }
            console.log('user', user)
          }
        })
      });
    },
    sendEmail() {
      var link = 'mailto:clockwisechain@gmail.com'
       // + '?cc=copy@example.com'
        + '?subject=' + encodeURIComponent('Email Subject')
        + '&body=' + encodeURIComponent('Email Body Text');
      window.location.href = link;
    },
    // 检查用户注册没
    async checkUser() {
      try {
        const contract = getMobileSaleContract();
        const storageContract = getSaleStorageContract();
        
        // 使用 getUserData 获取用户信息
        const userData = await storageContract.methods.getUserData(this.userAdd).call();
        const topReferrer = await contract.methods.topReferrer().call();
        console.log('topReferrer', topReferrer);
        // 解构返回的数据
        const {
            level,
            referrer,
            lastClaimTime,
            lastSZCClaimTime,
            totalEarnings,
            pendingEarnings,
            lastWithdrawalTime,
            directReferralCount,
            totalReferralEarnings,
            totalSalesAmount,
            pendingSZCRewards,
            totalSZCRewards
        } = userData;
        let purchasedProductId = userData.purchasedProductId;
        if(!purchasedProductId) {
          purchasedProductId = await contract.methods.getBytesProductId().call();
        };
        // 获取产品数据
        const productData = {};
        if (purchasedProductId) {
            const productInfo = await storageContract.methods.getProductData(this.userAdd, purchasedProductId).call();
            console.log("productInfo", productInfo, this.userAdd, purchasedProductId);
            productData[purchasedProductId] = {
                salesCount: productInfo.salesCount,
                salesAmount: productInfo.salesAmount,
                hasPurchased: productInfo.hasPurchased,
                productEarnings: productInfo.productEarnings,
                pendingProductEarnings: productInfo.pendingProductEarnings
            };
        }
        
        // 更新用户信息到 store
        await this.$store.dispatch('updateUserInfo', {
            level,
            referrer,
            lastClaimTime,
            lastSZCClaimTime,
            totalEarnings,
            pendingEarnings,
            lastWithdrawalTime,
            directReferralCount,
            totalReferralEarnings,
            totalSalesAmount,
            pendingSZCRewards,
            totalSZCRewards,
            purchasedProductId,
            productData
        });
        if(this.userAdd.toLowerCase() != topReferrer.toLowerCase()){
          // 如果用户没有推荐人且 window.refer 存在，显示绑定对话框
          if (referrer == '0x0000000000000000000000000000000000000000' && window.refer && web3.utils.isAddress(window.refer)) {
              this.showBindDialog = true;
          }
          if(referrer == '0x0000000000000000000000000000000000000000' && topReferrer && !window.refer){
            window.refer = topReferrer;
            this.showBindDialog = true;
            console.log('topReferrer', topReferrer, "window.refer", window.refer);
          }
        }

        return userData;
      } catch (error) {
        console.error('Error checking user:', error);
        throw error;
      }
    },
  },
};
</script>
<style lang="scss" src="../../scss/common.scss" />
<style lang="scss" scoped src="./index.scss" />